import { Component, effect, inject, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Contact, ContactCreated, ContactResponse } from "../../models/contact";
import { SharedContactRepository } from "../../repositories/shared-contact-repository";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SharedMessageRepositoryTable } from "../../repositories/shared-message-repository-table";
import { MessageDraft } from "../../models/message";
import { LoadingComponent } from "../loading/loading.component";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { GiveCreditsComponent } from "../give-credits/give-credits.component";
import { CreateContactComponent } from "../create-contact/create-contact.component";
import { NavStore, ScreenStore, UserStore } from "../../stores/index";
import { AddContactComponent } from "../add-contact/add-contact.component";
import { CellClickedEvent } from "ag-grid-community";
import { JhmTableComponent } from "../jhm-table/jhm-table.component";

@Component({
	selector: "jhm-contacts",
	templateUrl: "./contacts.component.html",
	styleUrls: ["./contacts.component.scss"],
	imports: [
		JhmTableComponent,
		GiveCreditsComponent,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		LoadingComponent,
		CreateContactComponent,
		AddContactComponent
	]
})
export class ContactsComponent implements OnDestroy
{
	public showNewContactModal: boolean = false;
	public refreshTableData: Subject<boolean> = new Subject();
	public currentTableData: Contact[] = [];
	public userType: string;
	public createNewContact: boolean = false;
	public createNewContactEmail: string;
	public loading: boolean = false;
	public showGiveCreditsModal: boolean = false;
	public contactToGive: Contact;
	public screenSize: string;
	public showAddContactModal: boolean = false;
	public ngDestroyed$: Subject<any> = new Subject();
	public isCivilianAccount: boolean = false;

	readonly userStore = inject(UserStore);
	readonly screenStore = inject(ScreenStore);
	readonly navStore = inject(NavStore);

	public constructor(public contactRepository: SharedContactRepository, private route: ActivatedRoute,
		private messageRepository: SharedMessageRepositoryTable, private router: Router)
	{
		// Debouncer for search query
		this.route.queryParams.subscribe((params: Params) =>
		{
			if (params.addContact)
			{
				this.showNewContactModal = true;
			}
		});

		effect(() => {
			this.userType = this.userStore.type();
			if(this.userType === "CIVILIAN")
			{
				this.isCivilianAccount = true;
			}
		})

		effect(() => {
			this.screenSize = this.screenStore.screenSize();
		})
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public onNewContactClick(): void
	{
		this.showNewContactModal = true;
		// if (this.isCivilianAccount) {
		// 	this.openCreateInmateContact();
		// }
		// else {
		// this.showNewContactModal = true;
		// }
	}

	public cellClicked(click: CellClickedEvent): void
	{
		if (!click.data.rowObject.hasBeenReleased) {
			if (click.colDef.field === "createDraft")
			{
				this.messageRepository.createMessageDraft(click.data.contactId).subscribe((draftSub: Observable<MessageDraft>) =>
				{
					draftSub.subscribe(
						(messageDraft: MessageDraft) =>
						{
							this.router.navigate(["drafts/messages/" + messageDraft.id]);
						});
				});
			}
			else if (click.colDef.field === "addCredits")
			{
				this.contactToGive = click.data.rowObject;
				this.showGiveCreditsModal = true;
			}
			else {

			}
		}
	}

	public cancelAddContact(): void
	{
		this.showNewContactModal = false;
		this.createNewContact = false;
	}

	public refreshData(): void
	{
		this.refreshTableData.next(true);
	}

	public contactAlreadyAdded(userId: string): boolean
	{
		return this.currentTableData.some((contact: Contact) => contact.contactId === userId);
	}

	public setCurrentTableData(currentTableData: Contact[]): void
	{
		this.currentTableData = currentTableData;
	}

	public openNav(): void
	{
		this.navStore.open();
	}

	public createContactExit(createdContact: ContactResponse): void
	{
		this.showAddContactModal = false;
		if (createdContact)
		{
			this.refreshData();
		}
	}

	public addContactExit(contactCreated: ContactCreated): void
	{
		this.showNewContactModal = false;
		if (contactCreated)
		{
			this.refreshData();
		}
	}
}
